import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import './styles.css';
import BottleSelectorLayout from '../BottleSelectorLayout';
import SetVariableMutation from '../../mutations/SetVariable';
import GameQuery from '../../query/GameQuery';
class BottleSelector extends Component {
	render() {
		const { variable } = this.props;
		return (
			<GameQuery>
				{query => (
					<SetVariableMutation>
						{setVariable => (
							<div
								className={`bottle-selector ${
									!variable.disabled
										? 'bottle-selector-active'
										: 'bottle-selector-disabled'
								}`}
							>
								<BottleSelectorLayout>
									<BottleSelectorLayout.Item
										onClick={() => this.handleClick(setVariable, 1, query.game)}
										active={variable.value === 1}
									>
										<Icon icon={'bottleStandard'} />
										<BottleSelectorLayout.ItemLabel
											label={'standard'}
											unit={'(0.30 €/u)'}
										/>
									</BottleSelectorLayout.Item>
									<BottleSelectorLayout.Item
										onClick={() => this.handleClick(setVariable, 2, query.game)}
										active={variable.value === 2}
									>
										<Icon icon={'bottleCustomised'} />
										<BottleSelectorLayout.ItemLabel
											label={'customized'}
											unit={'(0.35 €/u)'}
										/>
									</BottleSelectorLayout.Item>
									<BottleSelectorLayout.Item
										onClick={() => this.handleClick(setVariable, 3, query.game)}
										active={variable.value === 3}
									>
										<Icon icon={'bottlePremium'} />
										<BottleSelectorLayout.ItemLabel
											label={'premium'}
											unit={'(0.50 €/u)'}
										/>
									</BottleSelectorLayout.Item>
								</BottleSelectorLayout>
							</div>
						)}
					</SetVariableMutation>
				)}
			</GameQuery>
		);
	}
	handleClick(setVariable, value, game) {
		const { variable } = this.props;
		const { name, year } = variable;
		!variable.disabled &&
			setVariable({
				variables: {
					gameID: game.id,
					submission: game.lastSubmission,
					name,
					year,
					value
				}
			});
	}
}
BottleSelector.propTypes = {
	variable: PropTypes.object,
	onClick: PropTypes.func,
	active: PropTypes.bool
};
BottleSelector.defaultProps = {
	onClick: n => console.log('selected item', n)
};

export default BottleSelector;
